import { COUNTRY_OPTIONS, DEFAULT_COUNTRY } from "./options";

// A structured address: { lineOne, lineTwo, country, state, suburb, postcode },
// where `state` is the location API's state code, e.g. "NSW".
export function emptyAddress() {
  return { lineOne: "", lineTwo: "", country: DEFAULT_COUNTRY, state: "", suburb: "", postcode: "" };
}

// Address line 1, state, suburb and postcode are required; line 2 is optional.
export function isAddressComplete(address) {
  return (
    address.lineOne.trim() !== "" &&
    address.state !== "" &&
    address.suburb !== "" &&
    address.postcode.trim() !== ""
  );
}

/*
The address as one line, e.g.
"5 Murray Rose Ave, Sydney Olympic Park NSW 2127, Australia" - for the
pickup_address / delivery_address strings. Pass `includeCountry: false` for
on-screen display (the read-only "same as above" field), where the country is
hidden.
*/
export function formatAddress(address, { includeCountry = true } = {}) {
  const locality = [address.suburb, address.state, address.postcode.trim()]
    .filter(Boolean)
    .join(" ");
  const lines = [address.lineOne.trim(), address.lineTwo.trim(), locality].filter(Boolean);
  if (lines.length === 0) return "";
  if (!includeCountry) return lines.join(", ");

  const country = COUNTRY_OPTIONS.find(function (option) {
    return option.value === address.country;
  })?.label;
  return [...lines, country].filter(Boolean).join(", ");
}
